import {AccordionItemV2 as PeacockAccordionItem} from '@pepsico-ds/ui'
import './AccordionItem.scss'

/**
 * @typedef {import('@pepsico-ds/ui').IAccordionItemV2Props} AccordionItemProps
 */

/**
 * Wrapper around Peacock DS AccordionItemV2.
 * Supports all Peacock DS accordion item props.
 * @param {AccordionItemProps} props
 */
export const AccordionItem = props => {
  return <PeacockAccordionItem {...props} />
}
